import { Typography } from "@circle-react-uikit/Typography";
import type { ReactNode } from "react";

import { gridCols } from "./constants";

interface HeadingProps {
  children: ReactNode;
}

export const Heading = ({ children }: HeadingProps) => (
  <div className={`grid ${gridCols}`}>
    <div className="mb-6">
      <Typography.TitleSm weight="bold">{children}</Typography.TitleSm>
    </div>
  </div>
);
